export default __webpack_public_path__ + "static/media/hockey.d98eee2e.svg";